// import React, { useState, useEffect } from "react";

// const Testimonials = () => {
//     const [isMobile, setIsMobile] = useState(false);
//     const [hoveredCard, setHoveredCard] = useState(null);

//     useEffect(() => {
//         const handleResize = () => setIsMobile(window.innerWidth < 768);
//         handleResize();
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     // Premium hospitality and corporate luxury hotel client validation reviews
//     const reviews = [
//         {
//             initials: "VO",
//             name: "Vikram Oberoi",
//             role: "General Manager",
//             quote: "A17 has completely elevated our guest dining experience. Their custom, high-strength premium bottle architecture perfectly matches our luxury suite aesthetics while maintaining immaculate molecular water safety."
//         },
//         {
//             initials: "MK",
//             name: "Manish Kapoor",
//             role: "F&B Director",
//             quote: "Managing premium water inventory across multiple fine-dining banquets requires unmatched supply chain scale. A17 consistently delivers thousands of flawless, crystal-pure hydro batches on time."
//         },
//         {
//             initials: "SR",
//             name: "Siddharth Roy",
//             role: "Procurement Head",
//             quote: "We chose A17 as our primary indigenous manufacturing partner for pan-India luxury supply. Their zero-touch packaging and automated plant compliance ticks every single corporate quality audit effortlessly."
//         }
//     ];

//     const styles = {
//         wrapper: {
//             minHeight: "100vh",
//             width: "100%",
//             background: "#2c3437",
//             backgroundImage: "url('https://transparenttextures.com')",
//             backgroundRepeat: "repeat",
//             backgroundBlendMode: "multiply",
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: "center",
//             alignItems: "center",
//             fontFamily: "'Montserrat', sans-serif",
//             color: "white",
//             padding: isMobile ? "80px 20px" : "120px 40px",
//             boxSizing: "border-box",
//             position: "relative",
//             overflow: "hidden",
//         },
//         container: {
//             width: "100%",
//             maxWidth: "1100px",
//             zIndex: 2,
//             position: "relative",
//         },
//         headerSection: {
//             textAlign: isMobile ? "center" : "left",
//             display: "flex",
//             flexDirection: isMobile ? "column" : "row",
//             alignItems: isMobile ? "center" : "flex-end",
//             justifyContent: "space-between",
//             marginBottom: isMobile ? "40px" : "70px",
//             gap: "20px"
//         },
//         tagline: {
//             color: "#6ec1e4",
//             letterSpacing: "3px",
//             fontSize: isMobile ? "12px" : "14px",
//             fontWeight: "600",
//             textTransform: "uppercase",
//             marginBottom: "12px",
//         },
//         mainTitle: {
//             fontSize: isMobile ? "30px" : "44px",
//             fontWeight: "900",
//             letterSpacing: "1px",
//             lineHeight: 1.2,
//             color: "#ffffff",
//             margin: 0,
//         },
//         scrollHint: {
//             fontSize: "11px",
//             color: "#9ca3af",
//             letterSpacing: "2px",
//             textTransform: "uppercase",
//             fontWeight: "500",
//             opacity: 0.7,
//         },
//         cardsTrack: {
//             display: "flex",
//             gap: isMobile ? "20px" : "30px",
//             overflowX: "auto",
//             padding: "15px 5px 30px 5px",
//             scrollSnapType: "x mandatory",
//             WebkitOverflowScrolling: "touch",
//         },
//         card: (idx) => ({
//             scrollSnapAlign: "center",
//             flexShrink: 0,
//             width: isMobile ? "290px" : "calc(33.33% - 20px)",
//             backgroundColor: "rgba(255, 255, 255, 0.02)",
//             border: hoveredCard === idx ? "1px solid #6ec1e4" : "1px solid rgba(255, 255, 255, 0.08)",
//             borderRadius: "24px",
//             padding: isMobile ? "30px 24px" : "40px 32px",
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: "space-between",
//             transition: "all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
//             transform: !isMobile && hoveredCard === idx ? "translateY(-6px)" : "translateY(0)",
//             boxShadow: !isMobile && hoveredCard === idx ? "0px 15px 35px rgba(110,193,228,0.12)" : "none",
//             boxSizing: "border-box",
//         }),
//         quoteText: {
//             fontSize: isMobile ? "14px" : "15px",
//             color: "#e2e8f0",
//             fontWeight: "300",
//             fontStyle: "italic",
//             lineHeight: "1.7",
//             margin: "0 0 35px 0",
//         },
//         profileRow: {
//             display: "flex",
//             alignItems: "center",
//             gap: "16px",
//         },
//         avatar: (idx) => ({
//             width: "48px",
//             height: "48px",
//             borderRadius: "50%",
//             background: hoveredCard === idx 
//                 ? "linear-gradient(135deg, #6ec1e4 0%, #3a9cbd 100%)" 
//                 : "linear-gradient(135deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.02) 100%)",
//             border: hoveredCard === idx ? "1px solid #6ec1e4" : "1px solid rgba(255,255,255,0.1)",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             fontWeight: "700",
//             fontSize: "14px",
//             color: hoveredCard === idx ? "#2c3437" : "#6ec1e4",
//             transition: "all 0.3s ease",
//             letterSpacing: "1px",
//         }),
//         metaBox: {
//             display: "flex",
//             flexDirection: "column",
//             gap: "2px",
//         },
//         nameText: {
//             fontSize: "15px",
//             fontWeight: "700",
//             color: "#ffffff",
//             letterSpacing: "0.5px",
//         },
//         roleText: {
//             fontSize: "12px",
//             color: "#6ec1e4",
//             fontWeight: "500",
//             letterSpacing: "0.5px",
//         }
//     };

//     return (
//         <div id="reviews" style={styles.wrapper}>
//             <style dangerouslySetInnerHTML={{__html: `
//                 #testimonials-track {
//                     scrollbar-width: none !important;
//                     -ms-overflow-style: none !important;
//                 }
//                 #testimonials-track::-webkit-scrollbar {
//                     display: none !important;
//                 }
//             `}} />

//             <div style={styles.container}>
//                 <div style={styles.headerSection}>
//                     <div>
//                         <div style={styles.tagline}>Hospitality Validation</div>
//                         <h2 style={styles.mainTitle}>Trusted by 5-Star Luxury Hotels</h2>
//                     </div>
//                     <div style={styles.scrollHint}>
//                         {isMobile ? "Swipe to explore →" : "Scroll to browse →"}
//                     </div>
//                 </div>

//                 <div id="testimonials-track" style={styles.cardsTrack}>
//                     {reviews.map((rev, idx) => (
//                         <div
//                             key={rev.name}
//                             style={styles.card(idx)}
//                             onMouseEnter={() => setHoveredCard(idx)}
//                             onMouseLeave={() => setHoveredCard(null)}
//                         >
//                             <p style={styles.quoteText}>"{rev.quote}"</p>
                            
//                             <div style={styles.profileRow}>
//                                 <div style={styles.avatar(idx)}>
//                                     {rev.initials}
//                                 </div>
//                                 <div style={styles.metaBox}>
//                                     <span style={styles.nameText}>{rev.name}</span>
//                                     <span style={styles.roleText}>{rev.role}</span>
//                                 </div>
//                             </div>
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Testimonials;



import React, { useState } from "react";

const REVIEWS = [
  {
    initials: "VO",
    name: "Vikram Oberoi",
    role: "General Manager",
    quote:
      "A17 has completely elevated our guest dining experience. Their custom, high-strength premium bottle architecture perfectly matches our luxury suite aesthetics while maintaining immaculate molecular water safety."
  },
  {
    initials: "MK",
    name: "Manish Kapoor",
    role: "F&B Director",
    quote:
      "Managing premium water inventory across multiple fine-dining banquets requires unmatched supply chain scale. A17 consistently delivers thousands of flawless, crystal-pure hydro batches on time."
  },
  {
    initials: "SR",
    name: "Siddharth Roy",
    role: "Procurement Head",
    quote:
      "We chose A17 as our primary indigenous manufacturing partner for pan-India luxury supply. Their zero-touch packaging and automated plant compliance ticks every single corporate quality audit effortlessly."
  }
];

const Testimonials = ({ isMobile }) => {
  const [hoveredCard, setHoveredCard] = useState(null);

  return (
    <div
      id="reviews"
      style={{
        minHeight: "100vh",
        width: "100%",
        backgroundColor: "#2c3437",
        backgroundImage: "url('https://transparenttextures.com')",
        backgroundRepeat: "repeat",
        backgroundBlendMode: "multiply",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "'Montserrat', sans-serif",
        color: "white",
        padding: isMobile ? "80px 20px" : "120px 40px",
        boxSizing: "border-box",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <style
        dangerouslySetInnerHTML={{
          __html: `
            #testimonials-track {
              scrollbar-width: none !important;
              -ms-overflow-style: none !important;
            }
            #testimonials-track::-webkit-scrollbar {
              display: none !important;
            }
          `,
        }}
      />

      <div
        style={{
          width: "100%",
          maxWidth: "1100px",
          zIndex: 2,
          position: "relative",
        }}
      >
        {/* Header Section */}
        <div
          style={{
            textAlign: isMobile ? "center" : "left",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: isMobile ? "center" : "flex-end",
            justifyContent: "space-between",
            marginBottom: isMobile ? "40px" : "70px",
            gap: "20px",
          }}
        >
          <div>
            <div
              style={{
                color: "#6ec1e4",
                letterSpacing: "3px",
                fontSize: isMobile ? "12px" : "14px",
                fontWeight: "600",
                textTransform: "uppercase",
                marginBottom: "12px",
              }}
            >
              Hospitality Validation
            </div>
            <h2
              style={{
                fontSize: isMobile ? "30px" : "44px",
                fontWeight: "900",
                letterSpacing: "1px",
                lineHeight: 1.2,
                color: "#ffffff",
                margin: 0,
              }}
            >
              Trusted by 5-Star Luxury Hotels
            </h2>
          </div>
          {/* <div
            style={{
              fontSize: "11px",
              color: "#9ca3af",
              letterSpacing: "2px",
              textTransform: "uppercase",
              fontWeight: "500",
              opacity: 0.7,
            }}
          >
            {isMobile ? "Swipe to explore →" : "Scroll to browse →"}
          </div> */}
        </div>

        {/* Scrollable Cards Track */}
        <div
          id="testimonials-track"
          style={{
            display: "flex",
            gap: isMobile ? "20px" : "30px",
            overflowX: "auto",
            padding: "15px 5px 30px 5px",
            scrollSnapType: "x mandatory",
            WebkitOverflowScrolling: "touch",
          }}
        >
          {REVIEWS.map((rev, idx) => {
            const isHovered = hoveredCard === idx;
            return (
              <div
                key={rev.name}
                onMouseEnter={() => setHoveredCard(idx)}
                onMouseLeave={() => setHoveredCard(null)}
                style={{
                  scrollSnapAlign: "center",
                  flexShrink: 0,
                  width: isMobile ? "290px" : "calc(33.33% - 20px)",
                  backgroundColor: "rgba(255, 255, 255, 0.02)",
                  border: isHovered
                    ? "1px solid #6ec1e4"
                    : "1px solid rgba(255, 255, 255, 0.08)",
                  borderRadius: "24px",
                  padding: isMobile ? "30px 24px" : "40px 32px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  transition: "all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
                  transform:
                    !isMobile && isHovered
                      ? "translateY(-6px)"
                      : "translateY(0)",
                  boxShadow:
                    !isMobile && isHovered
                      ? "0px 15px 35px rgba(110,193,228,0.12)"
                      : "none",
                  boxSizing: "border-box",
                }}
              >
                <p
                  style={{
                    fontSize: isMobile ? "14px" : "15px",
                    color: "#e2e8f0",
                    fontWeight: "300",
                    fontStyle: "italic",
                    lineHeight: "1.7",
                    margin: "0 0 35px 0",
                  }}
                >
                  "{rev.quote}"
                </p>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                  }}
                >
                  <div
                    style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "50%",
                      background: isHovered
                        ? "linear-gradient(135deg, #6ec1e4 0%, #3a9cbd 100%)"
                        : "linear-gradient(135deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.02) 100%)",
                      border: isHovered
                        ? "1px solid #6ec1e4"
                        : "1px solid rgba(255,255,255,0.1)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: "700",
                      fontSize: "14px",
                      color: isHovered ? "#2c3437" : "#6ec1e4",
                      transition: "all 0.3s ease",
                      letterSpacing: "1px",
                    }}
                  >
                    {rev.initials}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "2px",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "15px",
                        fontWeight: "700",
                        color: "#ffffff",
                        letterSpacing: "0.5px",
                      }}
                    >
                      {rev.name}
                    </span>
                    {/* <span
                      style={{
                        fontSize: "12px",
                        color: "#6ec1e4",
                        fontWeight: "500",
                        letterSpacing: "0.5px",
                      }}
                    >
                      {rev.role}
                    </span> */}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Testimonials;